/**
 * # Notes
 *
 * A few tips about how cytoscape works, as unfortunately it's not that
 * easy to learn from the documentation.
 *
 *
 * ## Data and labels
 *
 * The elements property sent to cytoscape({ elements, ... }) is an
 * array of nodes and edges.
 *
 * Nodes and edges shall have a data property, where you can add any
 * metadata you want (and they must have an id). E.g.
 *
 * ```
 * {
 *   data: {
 *     id: 'unique id referenced by edges',
 *     name: 'some value',
 *   }
 * }
 * ```
 *
 * Then node.data.name will be accessible in the stylesheet as:
 *
 * node { // styling for nodes
 *   // Label is the text shown on the node
 *   label: data(name); // Show node.data.name on each node
 * }
 *
 *
 * ## Class-names and conditionaly styling
 *
 * You can also add class-names to style nodes conditionally:
 *
 * ```
 * {
 *   data: { ... }
 *   classes: ['example'],
 * }
 * ```
 *
 * which can be styled in the stylesheet:
 *
 * node.example {
 *   // custom style
 * }
 */

const cytoscapeStyles = `
  node {
    content: data(name);
    width: data(width);

    shape: round-rectangle;
    corner-radius: 4;

    /* style text */
    font-family: monospace;
    font-size: 13;

    text-valign: center;

    color: white;

    border-width: 1.5;
    border-style: solid;
    border-color: #555;
  }

  node.ready {
    background-color: #2e92f2;
  }
  node.waiting {
    background-color: #1f62a2;
  }
  node.running {
    background-color: #f4b90b;
  }
  node.worker-lost {
    border-color: #c62828;
    border-width: 3;
    border-style: dashed;
  }
  node.failed {
    background-color: #db0051;
  }
  node.completed {
    background-color: #24c75a;
  }
  node.reserved {
    background-color: #bb8bc1;
  }
  node.archived {
    background-color: #7f8287;
  }
  node.cancelled {
    background-color: #b7bcc3;
  }
  node.paused {
    background-color: #ffcfca;
  }

  node:selected {
    border-width: 3;
    border-color: black;
    overlay-opacity: 0;
  }

  node:active {
    overlay-opacity: 0;
  }

  edge {
    width: 1.5px;
    target-arrow-shape: triangle;
    arrow-scale: 0.75;
    curve-style: bezier;

    line-color: #bbb;
    target-arrow-color: #bbb;
    overlay-opacity: 0;
  }

  node.summary, node.pagination {
    background-color: #e8e8e8;
    background-opacity: 1;
    pie-size: 130%;
    pie-1-background-color: #db0051;
    pie-1-background-size: data(pie_failed);
    pie-2-background-color: #f4b90b;
    pie-2-background-size: data(pie_running);
    pie-3-background-color: #2e92f2;
    pie-3-background-size: data(pie_ready);
    pie-4-background-color: #1f62a2;
    pie-4-background-size: data(pie_waiting);
    pie-5-background-color: #ffcfca;
    pie-5-background-size: data(pie_paused);
    pie-6-background-color: #b7bcc3;
    pie-6-background-size: data(pie_cancelled);
    pie-7-background-color: #bb8bc1;
    pie-7-background-size: data(pie_reserved);
    pie-8-background-color: #24c75a;
    pie-8-background-size: data(pie_completed);
    pie-9-background-color: #7f8287;
    pie-9-background-size: data(pie_archived);
    text-outline-color: #555;
    text-outline-width: 0.75;
  }

  node.summary {
    padding: 10;
  }

  node.pagination {
    padding: 10;
  }

  .faded {
    opacity: 0.25;
    text-opacity: 0;
  }
`;
export default cytoscapeStyles;
